import React from "react";

interface TableLoadingSkeletonProps {
  rows?: number;
  columns?: number;
}

const COLUMN_WIDTHS = ["flex-1", "w-1/4", "w-1/5", "w-1/6", "w-1/4", "w-1/5"];

export default function TableLoadingSkeleton({
  rows = 5,
  columns = 4,
}: TableLoadingSkeletonProps) {
  const widths = COLUMN_WIDTHS.slice(0, columns);

  return (
    <div
      aria-label="Loading table"
      aria-live="polite"
      role="status"
      className="w-full space-y-2 p-2"
    >
      {/* Header row */}
      <div aria-hidden="true" className="mb-1 flex gap-4 motion-safe:animate-pulse">
        {widths.map((w, i) => (
          <div key={i} className={`h-7 rounded bg-slate-300 ${w}`} />
        ))}
      </div>
      {/* Content rows */}
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <div
          aria-hidden="true"
          key={rowIdx}
          className="flex gap-4 motion-safe:animate-pulse"
        >
          {widths.map((w, colIdx) => (
            <div
              key={colIdx}
              className={`h-6 rounded ${
                rowIdx % 2 === 0 ? "bg-slate-100" : "bg-slate-200"
              } ${w}`}
            />
          ))}
        </div>
      ))}
      <span className="sr-only">Loading table</span>
    </div>
  );
}
